import React from "react";
import { RCCInputMask } from "react-common-components";
import { Control, FieldValues } from "react-hook-form";
import { useTranslation } from "src/context/Translations/context";

export interface IInputHoursMinutes{
    name: string;
    defaultValue?: number;
    control: Control<FieldValues>;
    disabled: boolean;
}

const InputHoursMinutes: React.FC<IInputHoursMinutes> = ({
	name,
	defaultValue,
	control,
	disabled
}) => {
	const { translate } = useTranslation();

	const setEstimatedHours = (estimatedHours: number) => `${Math.floor(estimatedHours / 60).toString().padStart(4, "0")}:${(estimatedHours % 60).toString()}`;

	return(
		<>
			<RCCInputMask 
				name={name}
				control={control}
				label={`${translate("Horas Estimadas")} (${translate("horas")}:${translate("minutos")})`} 
				defaultValue={setEstimatedHours(defaultValue || 0)}
				format="####:##"
				required
				disabled={disabled}
			/>
		</>
	);
};

export default InputHoursMinutes;
